export function contentLoaderDone() {
    const event = new CustomEvent("pos/content_loader_done");
    document.dispatchEvent(event);
}